export class VueWorkingHoursAdminMonthView {
  private screenData: any;

  constructor(screenData: any) {
    this.screenData = screenData;
  }

  calculateTotalWorkedMinutes(): number {
    if (!this.screenData.monthInfo) return 0;

    let total = 0;
    this.screenData.monthInfo.forEach((week: any) => {
      week.forEach((day: any) => {
        if (!day.isEmpty) {
          total += day.totalMinutes || 0;
        }
      });
    });
    return total;
  }

  calculateTotalWorkedHours(): string {
    const totalMinutes = this.calculateTotalWorkedMinutes();
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours === 0) {
      return `${minutes} min`;
    } else if (minutes === 0) {
      return `${hours}h`;
    } else {
      return `${hours}h ${minutes}min`;
    }
  }

  calculateExpectedWorkingDays(): number {
    if (!this.screenData.monthInfo) return 0;

    let workingDays = 0;
    this.screenData.monthInfo.forEach((week: any) => {
      week.forEach((day: any) => {
        if (!day.isEmpty && day.date) {
          const date = new Date(day.date);
          const dayOfWeek = date.getDay();
          if (dayOfWeek >= 1 && dayOfWeek <= 5) {
            workingDays++;
          }
        }
      });
    });
    return workingDays;
  }

  calculateExpectedMinutes(): number {
    return this.calculateExpectedWorkingDays() * 8 * 60;
  }


  calculateExtraMinutes(): number {
    return this.calculateTotalWorkedMinutes() - this.calculateExpectedMinutes();
  }

  calculateExtraHoursText(): string {
    const extraMinutes = this.calculateExtraMinutes();
    const absMinutes = Math.abs(extraMinutes);
    const hours = Math.floor(absMinutes / 60);
    const minutes = absMinutes % 60;

    let timeText = '';
    if (hours === 0) {
      timeText = `${minutes} min`;
    } else if (minutes === 0) {
      timeText = `${hours}h`;
    } else {
      timeText = `${hours}h ${minutes}min`;
    }

    if (extraMinutes > 0) {
      return `+${timeText} (te deben)`;
    } else if (extraMinutes < 0) {
      return `-${timeText} (debes)`;
    } else {
      return `0h (equilibrado)`;
    }
  }


  calculateExtraHoursColor(): string {
    const extraMinutes = this.calculateExtraMinutes();

    if (extraMinutes > 0) {
      return '#4CAF50'; // Verde - te deben horas
    } else if (extraMinutes < 0) {
      return '#FF5722'; // Rojo - debes horas
    } else {
      return '#7339B7'; // Morado - equilibrado
    }
  }

  getMonthStatistics() {
    return {
      totalWorkedMinutes: this.calculateTotalWorkedMinutes(),
      totalWorkedHours: this.calculateTotalWorkedHours(),
      expectedWorkingDays: this.calculateExpectedWorkingDays(),
      expectedMinutes: this.calculateExpectedMinutes(),
      extraMinutes: this.calculateExtraMinutes(),
      extraHoursText: this.calculateExtraHoursText(),
      extraHoursColor: this.calculateExtraHoursColor()
    };
  }

  formatHoursAndMinutes(totalMinutes: number): string {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours === 0) {
      return `${minutes}min`;
    } else if (minutes === 0) {
      return `${hours}h`;
    } else {
      return `${hours}h ${minutes}min`;
    }
  }
}
